var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4005 18.9977C32.4051 20.1799 32.0187 21.3253 31.3011 22.2637C30.9009 22.7605 30.4731 23.2389 30.0223 23.6943L29.7463 23.9611C24.3459 28.9613 18.1865 33.0737 11.4981 36.1465C10.1457 36.7583 8.71512 37.1769 7.24312 37.3977H7.05912C4.94312 37.3885 3.00192 36.2247 1.99912 34.3617C1.52072 33.0369 1.15272 31.6753 0.899719 30.2907C0.402919 26.5463 0.172919 22.7697 0.200519 18.9977C0.131519 15.0831 0.393719 11.1731 0.977919 7.30452C1.18952 6.20052 1.46552 5.10572 1.80132 4.03852C2.32112 2.86092 3.21352 1.88572 4.34052 1.26932C5.24212 0.823124 6.23572 0.593124 7.24312 0.597724C8.54492 0.781724 9.81912 1.12672 11.0381 1.62812C17.8783 4.71472 24.1803 8.87772 29.7003 13.9607C30.3397 14.5909 31.0251 15.3453 31.2091 15.5293C31.9865 16.5183 32.4051 17.7419 32.4005 18.9977Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoButton);
export default __webpack_public_path__ + "static/media/video_button.abe5ba825cd8351ee9f55fc689778a42.svg";
export { ForwardRef as ReactComponent };